import { createGlobalStyle } from 'styled-components';

import { theme } from './theme';
const GlobalStyle = createGlobalStyle`
  body {
  font-family: 'Courier New', Courier, monospace; 
  color: white;
  background: #000000;
  margin: 0;
  }

  a {
    color: ${theme.colors.green};
    text-decoration: none;
  }

  :root {
    font-family: Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
    line-height: 1.5;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Courier New', Courier, monospace;
    margin: 0;
    font-weight: 600;
  }
  /* For WebKit-based browsers (Chrome, Safari) */
::-webkit-scrollbar {
  width: 12px; /* Width of the scrollbar */
}

::-webkit-scrollbar-track {
  background-color: black; /* Track background */
}

::-webkit-scrollbar-thumb {
  background-color: #1FCF5E; /* Scrollbar thumb */
  border-radius: 6px; /* Rounded corners for the scrollbar thumb */
}

/* For Firefox */
* {
  scrollbar-color: #1FCF5E black;
}

/* Optional: Hover effect */
::-webkit-scrollbar-thumb:hover {
  background-color: #1FCF5E; /* Hover effect for the thumb */
}

  #tidio-chat-iframe {
    bottom: 46px !important;
  }
`;
export default GlobalStyle;
